import { useEffect } from "react";

export const useAutoOpenTaskpane = () => {
  useEffect(() => {
    const enableAutoOpen = async () => {
      try {
        const settingName = "Office.AutoShowTaskpaneWithDocument";
        const settings = Office.context.document.settings;

        const currentValue = settings.get(settingName) as boolean | null;
        if (currentValue !== true) {
          console.log("Enabling AutoOpen Taskpane for this document...");
          settings.set(settingName, true);

          settings.saveAsync((result) => {
            if (result.status === Office.AsyncResultStatus.Failed) {
              console.error("Failed to save auto-open setting: " + result.error.message);
            } else {
              console.log("Auto-open taskpane set successfully for this document.");
            }
          });
        }
      } catch (error) {
        console.error("Error setting auto-open taskpane:", error);
      }
    };

    // Run once on mount
    enableAutoOpen();
  }, []);
};
